import React from 'react';
import { Metrics } from '../types/insights';
import { safeLowerCase, safeIncludes, safeNumber } from '../utils/safeString';

interface MetricsCardsProps {
  metrics: Metrics | null;
}

const MetricsCards: React.FC<MetricsCardsProps> = ({ metrics }) => {
  if (!metrics) {
    return null;
  }

  const getTrendIcon = (trend?: string) => {
    const lowerTrend = safeLowerCase(trend);
    if (safeIncludes(lowerTrend, 'up') || safeIncludes(lowerTrend, 'increase')) {
      return '↑';
    } else if (safeIncludes(lowerTrend, 'down') || safeIncludes(lowerTrend, 'decrease')) {
      return '↓';
    }
    return '';
  };

  const getTrendText = (trend?: string) => {
    if (!trend) return '';
    const lowerTrend = safeLowerCase(trend);
    if (safeIncludes(lowerTrend, 'baseline')) {
      return trend;
    }
    if (safeIncludes(lowerTrend, '%')) {
      return trend;
    }
    const icon = getTrendIcon(trend);
    return icon ? `${icon} ${trend}` : trend;
  };

  return (
    <div className="metrics-container">
      <div className="metric-card go2-score">
        <div className="metric-icon">⊙</div>
        <div className="metric-label">Go2 Score</div>
        <div className="metric-value">{safeNumber(metrics.go2_score)}%</div>
        <div className="metric-trend">{getTrendText(metrics.go2_score_trend)}</div>
        <div className="metric-info" title="Click for more info">?</div>
      </div>
      
      <div className="metric-card engagement">
        <div className="metric-icon">⚡</div>
        <div className="metric-label">My Engagement</div>
        <div className="metric-value">{safeNumber(metrics.engagement_score)}%</div>
        <div className="metric-trend">{getTrendText(metrics.engagement_trend)}</div>
        <div className="metric-info" title="Click for more info">?</div>
      </div>
    </div>
  );
};

export default MetricsCards;